import { UseForm } from "../../../../types/UseForm";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { ProductUnion } from "../../../../types/ProductUnion";

export default function personFields<T extends ProductUnion = ProductUnion>({
  path,
  isDisabled = () => false,
  isHidden = () => false,
  allowNoGender = true,
}: {
  path: string;
  isDisabled?: ({ product, values }: { product: T; values: UseForm["values"] }) => boolean;
  isHidden?: ({ product, values }: { product: T; values: UseForm["values"] }) => boolean;
  allowNoGender?: boolean;
}): FormElementPropsWithoutProduct<T>[] {
  return [
    {
      type: "ValidatorSelect",
      path: `${path}.gender`,
      isDisabled: isDisabled,
      isHidden: isHidden,
      additionalProps: { displayEmpty: allowNoGender },
      options: () => [
        ...(allowNoGender ? [{ value: "", label: "Keine Anrede" }] : []),
        { value: "male" },
        { value: "female" },
      ],
    },
    {
      type: "ValidatorTextField",
      path: `${path}.givenName`,
      isDisabled: isDisabled,
      isHidden: isHidden,
    },
    {
      type: "ValidatorTextField",
      path: `${path}.familyName`,
      isDisabled: isDisabled,
      isHidden: isHidden,
    },
  ];
}
